/**
 * Candela Collection Filters — AJAX subcategory dropdown
 *
 * On <select> change:
 * 1. Build filter URL with section_id param
 * 2. Fetch filtered section HTML from Shopify
 * 3. Swap #CandelaProductGrid content
 * 4. Update dropdown (counts may change)
 * 5. pushState for back/forward navigation
 */
class CandelaCollectionFilters extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    if (!this.select) return;

    this.sectionId = this.dataset.section;
    this._onFilterChange = this.onFilterChange.bind(this);
    this._onPopState = this.onPopState.bind(this);
    this.select.addEventListener('change', this._onFilterChange);
    window.addEventListener('popstate', this._onPopState);
  }

  disconnectedCallback() {
    if (this.select && this._onFilterChange) {
      this.select.removeEventListener('change', this._onFilterChange);
    }
    if (this._onPopState) {
      window.removeEventListener('popstate', this._onPopState);
    }
  }

  onFilterChange() {
    var url = this.buildUrl(this.select.value);
    this.fetchAndRender(url);
    history.pushState(null, '', url);
  }

  onPopState() {
    this.fetchAndRender(window.location.href);
  }

  buildUrl(value) {
    var url = new URL(window.location.href);
    var paramName = this.select.name;

    url.searchParams.delete(paramName);
    if (value) {
      url.searchParams.set(paramName, value);
    }
    url.searchParams.delete('page');
    return url.toString();
  }

  fetchAndRender(url) {
    var fetchUrl = new URL(url);
    fetchUrl.searchParams.set('section_id', 'candela-collection-grid');

    var grid = document.getElementById('CandelaProductGrid');
    if (grid) grid.style.opacity = '0.5';

    var self = this;
    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, 8000);

    fetch(fetchUrl.toString(), { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newGrid = doc.getElementById('CandelaProductGrid');
        if (newGrid && grid) {
          grid.style.opacity = '';
          while (grid.firstChild) grid.removeChild(grid.firstChild);
          while (newGrid.firstChild) grid.appendChild(newGrid.firstChild);
        }

        var newFilters = doc.querySelector('candela-collection-filters');
        var newSelect = newFilters ? newFilters.querySelector('select') : null;
        if (newSelect && self.select) {
          var currentValue = self.select.value;
          self.select.textContent = '';
          while (newSelect.firstChild) {
            self.select.appendChild(newSelect.firstChild);
          }
          self.select.value = currentValue;
        }
      })
      .catch(function (err) {
        if (grid) grid.style.opacity = '';
        if (err.name !== 'AbortError') {
          console.error('Collection filter:', err);
        }
      })
      .finally(function () {
        clearTimeout(timeoutId);
      });
  }
}

customElements.define('candela-collection-filters', CandelaCollectionFilters);
